import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getOfferDetailsUrl } from "../utils/urlHelper";

const offerDetailPageApi = createApi({
  reducerPath: "offerDetail",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.NEXT_PUBLIC_AUTH_URL}`,
    prepareHeaders: async (headers) => {
      const token = await sessionStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      headers.set("Accept", "application/json; version=3.0");
      headers.set("Source", "LPLWEB");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    stageStatus: builder.mutation({
      query: (body) => ({
        url: getOfferDetailsUrl("stage_status"),
        method: "POST",
        body,
      }),
    }),

    getAllOffers: builder.query({
      query: () => ({
        url: getOfferDetailsUrl("", true),
        method: "GET",
      }),
    }),

    getLoanInfo: builder.query({
      query: () => ({
        url: getOfferDetailsUrl("loan-info"),
        method: "GET",
      }),
    }),

    getEmiDetails: builder.mutation({
      query: (body) => ({
        url: getOfferDetailsUrl("get-emi-details"),
        method: "POST",
        body,
      }),
    }),

    createNewLoan: builder.mutation({
      query: (body) => ({
        url: getOfferDetailsUrl("create_new_loan_application"),
        method: "POST",
        body,
      }),
    }),

    getForeclosureData: builder.mutation({
      query: (body) => ({
        url: getOfferDetailsUrl("get-foreclosure-data"),
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useStageStatusMutation,
  useGetAllOffersQuery,
  useGetLoanInfoQuery,
  useCreateNewLoanMutation,
  useGetEmiDetailsMutation,
  useGetForeclosureDataMutation,
} = offerDetailPageApi;

export { offerDetailPageApi };
